import { Bolt } from "@mui/icons-material";
import { Paper } from "@mui/material";
import React from "react";
import { getIsPdp } from "../../Utils/pdpUtils";
import "./styles.css";

export default function PoweredByDathic({ disableAttributionLink = false }) {
  const isPdp = getIsPdp();
  return (
    <Paper
      sx={{
        position: "absolute",
        zIndex: 3,
        padding: "0px 8px",
        top: isPdp ? "unset" : 0,
        right: 0,
        bottom: isPdp ? 0 : "unset",
        backgroundColor: "rgba(252,252,252,0.25)",
        color: "#032536",
        fontSize: 11,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Bolt />{" "}
      {disableAttributionLink ? (
        <span id="dathic-powered">by Dathic</span>
      ) : (
        <a
          id="dathic-powered"
          href="https://dathic.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          by Dathic
        </a>
      )}
    </Paper>
  );
}
